import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { instantAccessItems } from '../data/content';
export function InstantAccess() {
  return <section className="w-full bg-cream px-5 py-20 sm:px-8" data-id="element-127" data-mp="1r92xlqguyj3s">
      <div className="mx-auto w-full max-w-3xl" data-id="element-128" data-mp="1r8je45bk7mnn">
        <Reveal data-id="element-129" data-mp="1vaeixjsp8i66">
          <h2 className="text-center text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-130" data-mp="1v9wmon61e3y9">
            Vad får du direkt?
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-131" data-mp="1m9q2yjjqw7qn">
          <ul className="mt-10 divide-y divide-sand rounded-3xl border border-sand bg-white px-7 py-4 sm:px-9" data-id="element-132" data-mp="1mb1e54fishrs">
            {instantAccessItems.map(item => <li key={item} className="flex items-start gap-4 py-5" data-id="element-133" data-mp="1cjx2oep1zf1p">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-level-green" data-id="element-134" data-mp="1ci3u2tuvqkr2">
                  <CheckIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-135" data-mp="13jid33523dse" />
                </span>
                <span className="text-[15px] font-semibold leading-relaxed text-navy" data-id="element-136" data-mp="1w4kyqyro0az8">
                  {item}
                </span>
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.12} data-id="element-137" data-mp="262qzve5ndd31">
          <p className="mt-10 text-center font-serif text-3xl leading-snug text-navy sm:text-4xl" data-id="element-138" data-mp="261pkwylig6g1">
            Du får aldrig slut på material.
          </p>
        </Reveal>
      </div>
    </section>;
}